import { useEffect, useState } from 'react';
import { TextInput, useResourceContext } from 'react-admin';
import { getCustomTableEdit } from '../components/CustomTableEdit';

const nonEditableFields = ['createdAt', 'updatedAt'];

const dataHandler = (fields, fieldName, fieldList, index) => {
    if (nonEditableFields.includes(fieldName)) {
        return true;
    }

    if (fieldName === 'password') {
        fieldList.push(<TextInput key={index} source={fieldName} type='password' />)
        return true;
    }

    return false;
};

const UserEdit = (props) => {
    const resource = useResourceContext(props);
    const [data, setData] = useState();

    useEffect(() => {
        getCustomTableEdit(resource, props, dataHandler).then((data) => setData(data));
    }, [ props, resource ]);

    if (data == null) {
        return <div></div>;
    }

    return data;
};

export default UserEdit;
